import React, { useMemo } from 'react';

import { useAccounts, useAppSelector, useAuthentication } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { useWalletStore } from '@app/store/zustand';

import { Icon } from '../../../SidebarNav/Icon';

import { IconWrapper, Label, StatusPip, StyledWalletButton } from './WalletButton.style';

export interface WalletButtonProps {
    mobileNav?: boolean;
}

export function WalletButton({ mobileNav = false }: WalletButtonProps) {
    const { quadHdY } = useMediaQuery();

    const { protectedAction } = useAuthentication();
    const { toggleShowOverview } = useWalletStore();
    const { connectedWallets } = useAccounts();
    const isRegisteredUser = useAppSelector((state) => state.user?.isRegisteredUser);

    function handleOpenWalletManager() {
        protectedAction(toggleShowOverview);
    }

    const requiresConnection = useMemo(
        () => !isRegisteredUser || !connectedWallets || connectedWallets.length === 0,
        [connectedWallets, isRegisteredUser],
    );
    const labelValue = requiresConnection ? 'Connect a wallet' : `${connectedWallets?.length} Connected`;
    const statusValue = requiresConnection ? 'red' : 'green';

    const iconMarkup = mobileNav ? null : (
        <IconWrapper>
            <Icon name="wallet" />
        </IconWrapper>
    );
    const labelMarkup = mobileNav || quadHdY ? <Label>{labelValue}</Label> : null;

    return (
        <StyledWalletButton $mobileNav={mobileNav} onAction={handleOpenWalletManager}>
            {iconMarkup}
            {labelMarkup}
            <StatusPip $mobileNav={mobileNav} $status={statusValue} />
        </StyledWalletButton>
    );
}
